import { map } from 'rxjs/operators';
import { LoggedUserService } from './loggeduser.service';
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { staticInfo } from '../staticInfo';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class HttpService {
  private token: any | undefined;

  public httpOptions: any = {
    headers: new HttpHeaders({
      Accept: 'application/json',
  'Content-Type': 'application/json'
      
    }),
  };

  constructor(
    private http: HttpClient,
    private loggedUser: LoggedUserService
  ) { }

  login(userData: { email: string; password: string; }) {
    // let URL = staticInfo.web_api_urls.login;
    let URL="https://backend.ibankhoms.sy/api/auth/login";
    return this.http.post(URL, userData, this.httpOptions);
  }

  signup(userData: any) {
    let URL = staticInfo.web_api_urls.signup;
    return this.http.post(URL, userData, this.httpOptions);
  }

  logout() {
    let URL = staticInfo.web_api_urls.logout;
    return this.http.post(URL, {}, this.httpOptions);
  }

  start() {
    let URL = staticInfo.web_api_urls.start;
    return this.http.get(URL, this.httpOptions);
  }

  subRegion(id?: number) {
    let URL = staticInfo.web_api_urls.sub_regions;
    URL = id ? URL + `/${id}` : URL;
    return this.http.get(URL, this.httpOptions);
  }

  populations(subRegionId?: undefined) {
    let URL = staticInfo.web_api_urls.populations;
    if (subRegionId) {
      URL = URL + `?sub_region_id=${subRegionId}`;
    }
    return this.http.get(URL, this.httpOptions);
  }

  agriculturalProducts() {
    let URL = staticInfo.web_api_urls.agricultural_products;
    return this.http.get(URL, this.httpOptions);
  }

  populationAgriculturalProduct(population_id: number) {
    let URL =
      staticInfo.web_api_urls.population_agricultural_products +
      `?population_id=${population_id}`;
    return this.http.get(URL, this.httpOptions);
  }

  agriculturalStatistics1(product_id: any) {
    let URL =
      staticInfo.web_api_urls.agricultural_statistics_1 +
      `?product_id=${product_id}`;
    return this.http.get(URL, this.httpOptions);
  }

  agriculturalStatistics2(product_id: any, sub_region_id: any, limit: number) {
    let URL =
      staticInfo.web_api_urls.agricultural_statistics_2 +
      `?product_id=${product_id}&sub_region_id=${sub_region_id}&limit=${limit}`;
    return this.http.get(URL, this.httpOptions);
  }

  agriculturalStatistics3(product_id: any, limit: number) {
    let URL =
      staticInfo.web_api_urls.agricultural_statistics_3 +
      `?product_id=${product_id}&limit=${limit}`;
    return this.http.get(URL, this.httpOptions);
  }

  agriculturalStatistics4(product_id: any, populations: any[]) {
    populations = populations.map((element) => element.id);
    let URL =
      staticInfo.web_api_urls.agricultural_statistics_4 +
      `?product_id=${product_id}&populations=${JSON.stringify(populations)}`;
    return this.http.get(URL, this.httpOptions);
  }

  productAmountsBySubRegion(sub_region_id: number) {
    let URL =
      staticInfo.web_api_urls.product_amounts_by_sub_region +
      `?sub_region_id=${sub_region_id}`;
    return this.http.get(URL, this.httpOptions);
  }

  report1() {
    let URL = staticInfo.web_api_urls.report_1;
    return this.http.get(URL, this.httpOptions);
  }

  report2() {
    let URL = staticInfo.web_api_urls.report_2;
    let observable = this.http.get(URL, this.httpOptions).pipe(
      map((resData: any) => {
        resData.data = resData.data.map((element: { administrative_unit_name: any; administrative_unit: { name: any; }; }) => {
          element.administrative_unit_name = element.administrative_unit.name;
          return element;
        });
        return resData;
      })
    );
    return observable;
  }

  // ?agricultural_product_type=0
  report3(agricultural_product_type?: any) {
    let URL = staticInfo.web_api_urls.report_3;
    if (agricultural_product_type === 0 || agricultural_product_type === 1) {
      URL += `?agricultural_product_type=${agricultural_product_type}`;
    }
    return this.http.get(URL, this.httpOptions);
  }

  report4(agricultural_product_id: any) {
    let URL = staticInfo.web_api_urls.report_4;
    if (agricultural_product_id) {
      URL += `?product_id=${agricultural_product_id}`;
    }
    let observable = this.http.get(URL, this.httpOptions).pipe(
      map((resData: any) => {
        resData.data = resData.data.map((element: { administrative_unit_name: any; administrative_unit: { name: any; }; }) => {
          element.administrative_unit_name = element.administrative_unit.name;
          return element;
        });
        return resData;
      })
    );
    return observable;
  }

  investment(with_crafts: boolean, id?: string): Observable<any> {
    // set request query params
    let params = new HttpParams();
    const httpOptions = Object.assign({}, this.httpOptions);
    if (with_crafts) params = params.set('with_crafts', String(with_crafts));
    if (id) params = params.set('id', id);
    httpOptions.params = params;

    let URL = `${staticInfo.web_api_urls.investments}`;

    return this.http.get(URL, httpOptions);
  }

  dams(): Observable<any> {
    let URL = `${staticInfo.web_api_urls.dams}`;
    return this.http.get(URL, this.httpOptions);
  }

  olivePresses(): Observable<any> {
    let URL = `${staticInfo.web_api_urls.olive_presses}`;
    return this.http.get(URL, this.httpOptions);
  }

  ruralDevelopmentProjects(type: 'animal' | 'agri'): Observable<any> {
    let params = new HttpParams();
    const httpOptions = Object.assign({}, this.httpOptions);
    params = params.set('type', String(type));
    httpOptions.params = params;

    let URL = `${staticInfo.web_api_urls.rural_development_projects}`;

    return this.http.get(URL, httpOptions);
  }

  getAlAssiRiver(): Observable<any> {
    let URL = '/assets/jeoJson/alassi-river.geojson';
    return this.http.get(URL, this.httpOptions);
  }

  getIrrigationChannels(): Observable<any> {
    let URL = '/assets/jeoJson/irrigationChannels.geojson';
    return this.http.get(URL, this.httpOptions);
  }

  // for wheat crop
  getAssociationCollaborations(): Observable<any> {
    let URL = staticInfo.web_api_urls.wheat_crop;
    return this.http.get(URL, this.httpOptions);
  }
  // 

  // demographic statistics by population
  demoStatisticsByPopulation(population_id :any) {
    let URL = staticInfo.web_api_urls.demo_statistics_by_population;
    const params = new HttpParams().set('population_id', population_id);
    return this.http.get(URL, { ...this.httpOptions, params });
  }

  search(searchText: string) {
    let URL = staticInfo.web_api_urls.search + searchText;
    return this.http.get(URL, this.httpOptions);
  }

  // header settings
  setAuthorizationHeader(token: string) {
    this.httpOptions.headers = this.httpOptions.headers.set(
      'Authorization',
      'Bearer ' + token
    );
  }

  setHeaders() {
    if (this.loggedUser.isLoggedIn()) {
      this.token = this.loggedUser.getAuthorizationToken();
      this.setAuthorizationHeader(this.token);
    }
  }
}
